import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GetLinkRequestModel } from '../models/community';
import { CommunityProgramsEndpoint } from './+products/community/community-programs-endpoint.service';

@Injectable({
    providedIn: 'root'
})
export class CommunityService {

    constructor(private communityEndpoint: CommunityProgramsEndpoint) { }

}
